// extracted by mini-css-extract-plugin
export default {"component":"Z91mkO","content":"YD3TLb"};